import React, { useState, useMemo } from 'react';
import { Select, Avatar } from 'antd-v5';
import { useSelector } from 'react-redux';

const SAMPLE_CLIENTS = [
  {
    id: 1,
    name: 'Emily Johnson',
    avatar: '#3aa4fc',
    reviewLink: 'https://g.co/r/downtown-boutique',
    appointmentDate: 'Jan 15, 2026',
    appointmentTime: '2:00 PM',
  },
  {
    id: 2,
    name: 'Michael Chen',
    avatar: '#f5a623',
    reviewLink: 'https://g.co/r/westside-gallery',
    appointmentDate: 'Feb 3, 2026',
    appointmentTime: '10:30 AM',
  },
  {
    id: 3,
    name: 'Sophia Williams',
    avatar: '#7b61ff',
    reviewLink: 'https://g.co/r/lakeside-mall',
    appointmentDate: 'Mar 22, 2026',
    appointmentTime: '4:15 PM',
  },
  {
    id: 4,
    name: 'Carlos Rivera',
    avatar: '#50c878',
    reviewLink: 'https://g.co/r/harbor-square',
    appointmentDate: 'Apr 10, 2026',
    appointmentTime: '11:00 AM',
  },
  {
    id: 5,
    name: 'Olivia Thompson',
    avatar: '#e74c6f',
    reviewLink: 'https://g.co/r/parkview-plaza',
    appointmentDate: 'May 8, 2026',
    appointmentTime: '1:45 PM',
  },
];

const MessagePreview = ({ messageText, attachments = [] }) => {
  const auth = useSelector(state => state.auth);
  const [selectedClientId, setSelectedClientId] = useState(SAMPLE_CLIENTS[0].id);

  const associateName = [auth.firstName, auth.lastName].filter(Boolean).join(' ') || 'Associate';
  const storeName = auth.stores?.find(s => s.id === auth.storeId)?.name || 'Store';
  const merchantName = auth.brandName || 'Merchant';

  const selectedClient = useMemo(
    () => SAMPLE_CLIENTS.find(c => c.id === selectedClientId) || SAMPLE_CLIENTS[0],
    [selectedClientId],
  );

  // Build the substituted preview text
  const previewText = useMemo(() => {
    if (!messageText) return '';
    let text = messageText;

    const substitutions = {
      ':name:': selectedClient.name,
      ':associate:': associateName,
      ':assigned_associate_name:': associateName,
      ':store:': storeName,
      ':merchant:': merchantName,
      ':review_link:': selectedClient.reviewLink,
      ':appointment_date:': selectedClient.appointmentDate,
      ':appointment_time:': selectedClient.appointmentTime,
    };

    Object.entries(substitutions).forEach(([token, value]) => {
      text = text.replace(new RegExp(token.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'g'), value);
    });

    return text;
  }, [messageText, selectedClient, associateName, storeName, merchantName]);

  const clientOptions = useMemo(
    () =>
      SAMPLE_CLIENTS.map(c => ({
        value: c.id,
        label: (
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <Avatar size={20} style={{ backgroundColor: c.avatar, fontSize: 10 }}>
              {c.name[0].toUpperCase()}
            </Avatar>
            <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{c.name}</span>
          </div>
        ),
      })),
    [],
  );

  return (
    <div className="mass-message-form__preview">
      <Select
        className="mass-message-form__preview-client-select"
        placeholder="Preview as client..."
        value={selectedClientId}
        onChange={setSelectedClientId}
        options={clientOptions}
        popupMatchSelectWidth={false}
        style={{ width: '100%' }}
        size="small"
      />

      <div className="mass-message-form__preview-body">
        <div className="mass-message-form__preview-bubble">
          <div className="mass-message-form__preview-bubble-text">
            {previewText || 'Your message will appear here...'}
          </div>
          {attachments.length > 0 && (
            <div className="mass-message-form__preview-attachments">
              {attachments.map((att, i) => {
                const url = typeof att === 'string' ? att : att.url;
                return url && !att.uploading ? (
                  <img key={att.id || i} src={url} alt="" className="mass-message-form__preview-att-img" />
                ) : null;
              })}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default MessagePreview;
